let isprod = true

export const ProvOrDev = {
  apiUrl: isprod ? 'http://gateway.shgkpx.cn' : 'http://erp-test99.shgkpx.club:16006' ,
  returnUrl: isprod ? 'http://vue.shgkpx.net' : 'http://pcma-exam.shgkpx.club' ,
  cryptoKey: isprod ? 'GKJY1803SHInt5fa' : 'GKJY1803SHInt5fa' //MIGfMA0GCSqGSIb3
}

export const codeToName = {
  200426: 'Examtype',
  200427: 'Indentity',
  200428: 'UploadAvatar',
  200429: 'BasicInfo',
  200430: 'Others',
  200431: 'Comfirm',
  200432: 'CheckStatus',
  200433: 'CheckStatus',
  200434: 'CheckStatus',
  200435: 'CheckStatus',
  200436: 'CheckStatus',
  200437: 'CheckStatus'
}


// WEBPACK FOOTER //
// ./src/util/const.js